import fixNumber from 'services/utils/fixNumber'
import createLabelFormatter from './createLabelFormatter'

function numberFormatter(n) {
  return `${fixNumber(n).toLocaleString()}`
}

export const numberLabelFormatter = createLabelFormatter(numberFormatter)

export default numberFormatter



// WEBPACK FOOTER //
// ./src/services/formatters/numberFormatter.js